import { useEffect } from "react";
import Lenis from "lenis";

export default function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 0.8,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      // Let Lenis own its rAF loop. The hand-rolled loop it replaces only ever
      // cancelled its first frame, so the loop survived unmount and kept
      // ticking against a destroyed instance; destroy() cancels this one.
      autoRaf: true,
    });

    // Expose globally so route-change scroll resets can use it
    window.__lenis = lenis;

    return () => {
      lenis.destroy();
      if (window.__lenis === lenis) delete window.__lenis;
    };
  }, []);

  return null;
}
